







































































import { SharedState } from "@/common/state";
import { UseModal } from "@/components/root/modal";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import RiskTypesModalVue from "@/views/customize/in-motion/risk-types/RiskTypesModal.vue";
import RiskyEventsModalVue from "@/views/detection/information-board/RiskyEventsModal.vue";
import AskForJustificationPolicyScriptModalVue from "@/views/customize/in-motion/security-policies/ask-for-justification/AskForJustificationPolicyScriptModal.vue";
import Vue from "vue";
import Chart from "chart.js/auto";
import DashboardCard from "../../DashboardCard.vue";
import { state } from "../../data/state";
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { UseCssVars } from "@/common/composition/use-css-var";
import { CountItem } from "../../data/model";
import SeveritiesBtns from "./SeveritiesBtns.vue";
import { ICONS } from "@/common/icons.map";
import InfoTypeSeveritiesModalVue from "@/views/detection/information-board/infotype-severities-modal/InfoTypeSeveritiesModal.vue";
export default Vue.extend({
  props: ["source"],
  components: { DashboardCard, SkeletonLoaderItem, SeveritiesBtns },
  setup(props) {
    const { loading, info_risk_events } = state;

    const hover_app_id = ref("");

    const playbook_desc = computed(() => {
      if (props.source && props.source == "google_workspace") {
        return "";
      } else {
        return `Automate justification requests sent to users creating risks`;
      }
    });

    const show_risk_types_modal = () => {
      if (
        SharedState.restrictions.is_restricted_app("risk_type_customization")
      ) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "Risk Type Customization"
        );
        return;
      }
      UseModal().show(RiskTypesModalVue);
    };

    const show_risky_events_modal = async () => {
      await UseModal().show(RiskyEventsModalVue);
    };

    const show_automate_justification_playbook = () => {
      SharedState.ifUserEnabledFeature(
        "justification_automation",
        async () => {
          const label = SharedState.l0_known_content_info_types.value[0];
          await UseModal().show(AskForJustificationPolicyScriptModalVue, {
            label_id: label.id,
            label_name: label.labelName,
          });
        },
        { premium_modal_key: "securitypolicies-popup-2024" }
      );
    };

    const get_label_ids_for_display = (info_type_id: string) => {
      const l1s = SharedState.get_raw_info_types_tree().find(
        (f) => f.id === info_type_id
      )?.nested;
      // @ts-ignore
      const real_l1s = l1s?.filter((d) => !d.fake);
      if (real_l1s && real_l1s.length > 0) {
        return [info_type_id, ...real_l1s?.map((d) => d.id)];
      } else {
        return l1s
          ?.map((d) => {
            if (d.nested && d.nested.length > 0) {
              return d.nested.map((d) => d.id);
            } else {
              return [];
            }
          })
          .flat()
          .filter((d) => d);
      }
    };

    const show_l1s_for_l0 = async (item: CountItem) => {
      const label = SharedState.getInfoType(item.id)!;
      if (SharedState.restrictions.is_restricted_info(label.code)) {
        SharedState.restrictions.show_restrictions_modal(
          "info",
          label.labelName
        );
        return;
      }
      // get all the nested labels -> L1
      // if there are no real L1 labels, then show the L2 labels
      const label_ids = get_label_ids_for_display(item.id);
      console.log("label_ids : ", label_ids);
      await UseModal().show(InfoTypeSeveritiesModalVue, {
        label_name: label.labelName,
        label_icon: ICONS.L0_ICONS.get(label.code),
        label_ids,
      });
    };

    const create_chart = (items: CountItem[]) => {
      const colors = UseCssVars(
        "--primary",
        "--main-1",
        "--main-2",
        "--main-3",
        "--lightest",
        "--dark"
      );
      new Chart(document.getElementById("the-chart") as HTMLCanvasElement, {
        type: "doughnut",
        // @ts-ignore
        options: {
          plugins: {
            tooltip: {
              enabled: false,
            },
            legend: {
              display: false,
            },
          },
          onHover: function(event, chartElement) {
            if (chartElement.length > 0) {
              const { index } = chartElement[0];
              hover_app_id.value = info_risk_events.value[index].id;
            }
          },
          onClick: (evt, item) => {
            if (item.length > 0) {
              const index = item[0].index;
              const counter_item = info_risk_events.value[index];
              show_l1s_for_l0(counter_item);
              const datasetIndex = item[0].datasetIndex;
              console.log(
                `Clicked on index ${index} in dataset ${datasetIndex}`
              );
            }
          },
        },
        data: {
          labels: items.map((d) => d.name),
          datasets: [
            {
              label: "",
              data: items.map((d) => d.count),
              backgroundColor: colors,
              hoverOffset: 4,
            },
          ],
        },
      });
    };

    const are_all_counters_zero = computed(
      () =>
        !loading.value.is_loading &&
        info_risk_events.value.every((d) => d.count == 0)
    );

    onMounted(() => {
      watch(
        loading,
        (val) => {
          if (!val.is_loading) {
            create_chart(info_risk_events.value);
          }
        },
        { deep: true }
      );
    });

    return {
      hover_app_id,
      playbook_desc,
      show_risk_types_modal,
      loading,
      are_all_counters_zero,
      show_l1s_for_l0,
      show_risky_events_modal,
      info_risk_events,
      show_automate_justification_playbook,
    };
  },
});
